import { makeStyles } from '@mui/styles';
import * as colors from 'apollo-react/colors';
import Tooltip from 'apollo-react/components/Tooltip';
import * as icons from 'apollo-react-icons';
import classNames from 'classnames';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import ControlChangesIcon from '../components/ControlChangesIcon';
import { FCM_BORDER_STYLES } from '../constants/runtime.constants';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
  },
  iconInEditor: {
    justifyContent: 'center',
  },
  iconText: {
    paddingLeft: 10,
  },
  changesIcon: {
    paddingRight: 8,
  },
  changesModeWrapper: {
    display: 'inline-flex',
    padding: 8,
    border: FCM_BORDER_STYLES.CONDITIONAL,
  },
});

const SSIcon = ({
  id,
  icon = '',
  fontSize,
  color,
  dataToolTip,
  isEditor,
  isControlAddedFCM,
  isControlChangedFCM,
}) => {
  const classes = useStyles({ isControlAddedFCM });
  const translateString = useTranslation();

  const Icon = icons[icon];

  if (!icon || !Icon) {
    return (
      <div className={classes.iconText} ui-ta={getUITA('FormCtrl', 'SSIcon')}>
        {translateString('Icon')}
      </div>
    );
  }

  const iconProps = {
    fontSize,
    htmlColor: colors[color],
  };

  return (
    <div ui-ta={getUITA('FormCtrl', 'SSIcon')} data-ss-id={id}>
      <div
        className={classNames(
          classes.root,
          isEditor && classes.iconInEditor,
          (isControlAddedFCM || isControlChangedFCM) && classes.changesModeWrapper
        )}
      >
        {dataToolTip ? (
          <Tooltip variant="light" title={dataToolTip} placement="bottom">
            <Icon {...iconProps} />
          </Tooltip>
        ) : (
          <Icon {...iconProps} />
        )}
        {isControlChangedFCM && (
          <span className={classes.changesIcon}>
            <ControlChangesIcon id={id} />
          </span>
        )}
      </div>
    </div>
  );
};

export default SSIcon;
